//extracted by mini-css-extract-plugin
export default {"sectionContainer":"styles_sectionContainer__eweLe","notificationSectionLabel":"styles_notificationSectionLabel__EPCrX"};;